import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

interface SkeletonProps {
  width?: string;
  height?: string;
  radius?: string;
  circle?: boolean;
  block?: boolean;
  style?: React.CSSProperties;
}

const skeletonProgress = keyframes`
0% {
  left: -500px;
}
100% {
  left: 100%;
}
`;

const SkeletonWrapper = styled.div`
  line-height: 1;
  display: inline-block;
  overflow: hidden;
  position: relative;
  background: var(--color-i-icon-dark-base);

  &::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 500px;
    top: 0;
    left: -500px;
    background-image: var(--color-i-icons-skeleton-gradient);
    animation: ${skeletonProgress} 1.2s ease-in-out infinite;
  }
`;

const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  radius,
  circle,
  block,
  style
}) => {
  return (
    <SkeletonWrapper
      style={{
        width,
        height,
        borderRadius: circle ? '50%' : radius,
        display: block ? 'block' : 'inline-block',
        ...style
      }}
    >
      &zwnj;
    </SkeletonWrapper>
  );
};

Skeleton.defaultProps = {
  width: '100%',
  height: '1rem',
  radius: '4px',
  block: true,
  style: {}
};

export default Skeleton;
